// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__35E13","title":"Header_title__1pZeR","left":"Header_left__3eJ1Z","clinicName":"Header_clinicName__3ebya"};